'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var response = function response(request, callback, data) {
	this.socket.removeAllListeners('response_' + request);
	var response = JSON.parse(data);
	if (response.error) {
		if (__DEVELOPMENT__) {
			console.log('API Error', response.error);
		}
		callback(response.error, null);
	} else {
		try {
			var json = JSON.parse(data);
			if (json) {
				if (__DEVELOPMENT__) {
					console.log('API Response', json);
				}
				callback(null, json.result);
			}
		} catch (e) {
			if (__DEVELOPMENT__) {
				console.log('API Error', data);
			}
			callback(data, null);
		}
	}
};

var WebsocketsRpc = function WebsocketsRpc(socket) {
	this.socket = socket;
};

WebsocketsRpc.prototype.call = function (method, args, callback) {
	var jsonRequest = this.buildRequest(method, { params: args });
	var rid = _uuid2['default'].v4();
	var data = { request: rid, json: jsonRequest };
	this.socket.on('response_' + rid, response.bind(this, rid, callback));
	this.socket.emit('api', data);
	if (__DEVELOPMENT__) {
		console.log('API Request', data);
	}
};

WebsocketsRpc.prototype.buildRequest = function (method, options) {
	if (options === undefined) {
		options = { id: 1 };
	}
	if (options.id === undefined) {
		options.id = 1;
	}
	var dataObj = {
		jsonrpc: '2.0',
		method: method,
		id: options.id
	};
	if (options.params !== undefined) {
		dataObj.params = options.params;
	}
	return dataObj;
};

exports['default'] = WebsocketsRpc;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/transport/websockets.js
 ** module id = 1039
 ** module chunks = 2
 **/